import { configureStore } from '@reduxjs/toolkit';
import sharedReducer, { sharedActions } from './slices/sharedSlice';
import featuresReducer, { featuresActions } from './slices/featuresSlice';

const store = configureStore({
    reducer: {
        shared: sharedReducer,
        features: featuresReducer
    }
});

// Re-export actions for convenience
// You can import { sharedActions, featuresActions } from '../store'
export { sharedActions, featuresActions };

// Legacy export for backward compatibility with existing code
// Components using appActions will still work
export const appActions = sharedActions;

export default store;
